export default __webpack_public_path__ + "static/media/sortup.5b30ece8.svg";